import { authenticatedGet } from "../../../api/authenticatedFetch";

const BASE = "/api/v1/ai";

// buildTrendsQuery turns the view's scope into query params. Only non-empty
// values are sent, so absent means "server default" rather than an explicit
// empty value. Filters ride as comma-separated field:value pairs; repeated
// fields merge into one clause server-side.
export function buildTrendsQuery(scope = {}) {
  const q = {};
  if (scope.from) q.from = scope.from;
  if (scope.to) q.to = scope.to;
  if (scope.breakdown) q.breakdown = scope.breakdown;
  if (scope.comparison) q.comparison = scope.comparison;
  const pairs = (scope.filters || []).flatMap((f) =>
    (f.values || []).map((v) => `${f.field}:${v}`)
  );
  if (pairs.length) q.filters = pairs.join(",");
  return q;
}

// The Go backend wraps every payload under a named key (writeJSON(..., "trends")).
// Unwrap here so callers read fields directly; fall back to the raw body.
function unwrap(body) {
  return body && body.trends !== undefined ? body.trends : body;
}

// fetchAiTrends GET /api/v1/ai/trends — the whole Trends page in one payload.
export async function fetchAiTrends(scope = {}) {
  return unwrap(await authenticatedGet(`${BASE}/trends`, buildTrendsQuery(scope)));
}
